var _path, _path2, _circle, _path3, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCashMoneyAlt(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33301 9.16671C3.33301 8.70647 3.7061 8.33337 4.16634 8.33337H15.833C16.2932 8.33337 16.6663 8.70647 16.6663 9.16671V15.8334C16.6663 16.2936 16.2932 16.6667 15.833 16.6667H4.16634C3.7061 16.6667 3.33301 16.2936 3.33301 15.8334V9.16671Z",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.4592L16.7309 10.442C17.1755 10.3228 17.4393 9.86589 17.3202 9.42133L15.5947 2.98183C15.4756 2.53727 15.0186 2.27345 14.5741 2.39257L3.30494 5.41213C2.86038 5.53124 2.59656 5.98819 2.71568 6.43275L3.44822 9.16663",
    stroke: "#4B5563",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9.99967,
    cy: 12.5,
    r: 1.66667,
    fill: "#4B5563"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0833 7.91667C12.0833 8.83714 11.3371 8.75 10.4167 8.75C9.49619 8.75 8.75 8.83714 8.75 7.91667C8.75 6.99619 9.49619 6.25 10.4167 6.25C11.3371 6.25 12.0833 6.99619 12.0833 7.91667Z",
    fill: "#4B5563"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.417,
    cy: 9.58337,
    r: 1.25,
    fill: "#4B5563"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3727,
    cy: 3.61423,
    r: 1.25,
    transform: "rotate(-15 14.3727 3.61423)",
    fill: "#4B5563"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.58301,
    cy: 9.58337,
    r: 1.25,
    fill: "#4B5563"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.16699,
    cy: 6.66663,
    r: 1.25,
    fill: "#4B5563"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.417,
    cy: 15.4166,
    r: 1.25,
    fill: "#4B5563"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 4.58301,
    cy: 15.4166,
    r: 1.25,
    fill: "#4B5563"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashMoneyAlt);
export default __webpack_public_path__ + "static/media/cash-money-alt.00c85906c939052e1167ffd4101b91dc.svg";
export { ForwardRef as ReactComponent };